import { IAccountConciliation } from "src/@types/deposit-conference";

export const hasNullOrZero = (data: any): boolean => {
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      const value = data[key];
      if (value === null || value === "" || value === 0) {
        return true;
      }
    }
  }
  return false;
};

export const handleOrderByEvidence = (data: IAccountConciliation[] | undefined, orderBy: string) => {
  if (!data || !data?.length) return []
  if (orderBy !== "asc" && orderBy !== "desc") return data

  return []
} 